import type { ApplyCouponPayload, ApplyCouponResponse } from "@api/applyCoupon";
import { applyCoupon } from "@api/applyCoupon";
import { useMutation } from "@tanstack/react-query";

export const useApplyCoupon = () =>
  useMutation<ApplyCouponResponse, Error, ApplyCouponPayload>({
    mutationFn: applyCoupon,
  });
